import React, { useMemo } from 'react'
import BaseModal from './Base'
import type { ButtonType } from '../CouponButton'
import CouponButton, { Origin } from '../CouponButton'
import type { ActionType } from './utils'
import { toButtonType } from './utils'
import type { Coupon } from 'shared-types/Coupon'
import type { LanguageLocale } from 'utils/language'
import type CouponError from 'mobx/Coupons/errors'
import CouponsStore from 'mobx/Coupons'

interface Props {
	coupon: Coupon
	locale: LanguageLocale
	actionType: ActionType
	secondActionType?: ActionType
	error?: string
	onError: (error: CouponError, actions: Record<ButtonType, () => Promise<void>>, disableSnackbar?: boolean) => void
	save: boolean
	info?: JSX.Element
	disabled?: boolean
	onClose?: () => void
}

const SignInModal: React.FC<Props> = ({ coupon, locale, info, actionType, secondActionType, save, disabled, onClose, onError, error }) => {
	const localizedCoupon = useMemo(() => CouponsStore.localizeCoupon(coupon, locale), [coupon, locale])

	return (
		<BaseModal
			coupon={localizedCoupon}
			info={info}
			button={
				<>
				<CouponButton
					coupon={coupon}
					variant={toButtonType(actionType, { save, applied: false, signIn: true })}
					onError={onError}
					disabled={disabled}
					origin={Origin.MODAL}
				/>
				{secondActionType &&
					<CouponButton
						coupon={coupon}
						variant={toButtonType(secondActionType, { save, applied: false, signIn: true })}
						onError={onError}
						disabled={disabled}
						origin={Origin.MODAL}
					/>
				}
				</>
			}
			onClose={onClose}
			error={error}
		/>
	)
}

export default SignInModal
